<template>
  <div id="footer" class="container-fluid">
   
    <p class="title">深圳市智波科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：广东深圳市宝安区西乡街道固兴社区盛滔前海产业园B303</span>
      <span>Tel：tyz@zhibotech.com.cn</span>
    </p>
    <p class="email_wx">
      <span>邮箱：tyz@zhibotech.com.cn</span>
      <span>公司微信号：sztyzhi</span>
    </p>
    <p class="copy">©2021 深圳智波科技有限公司保留所有权利</p>
    <a class="copy" href="https://beian.miit.gov.cn"> 备案号：粤ICP备2022052317号-1</a>
    <br/>
    <p>建议采用 Chrome 或者1280*768及以上分辨率或更高的浏览器版本浏览</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue